<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    :class="contextClassName"
  >
    <path
      d="M13.2255 3.70718L5.93235 11.0003H21.9999V13.0003H5.93235L13.2255 20.2934L11.8115 21.7072L2.10449 12.0002L11.8115 2.29321L13.2255 3.70718Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
  interface IProps {
    direction?: 'left' | 'right' | 'up' | 'down';
  }

  const props = withDefaults(defineProps<IProps>(), {
    direction: 'left',
  });

  const contextClassName = computed((): string => {
    return (() => {
      switch (props.direction) {
        case 'right':
          return 'rotate-180';
        case 'up':
          return 'rotate-90';
        case 'down':
          return '-rotate-90';
        default:
          return '';
      }
    })();
  });
</script>
